<template>
  <div>
    <p style="font-family:cursive;font-style:italic;font-weight:bold;font-size:18px">{{settings&&settings.shop?settings.shop.name:"Adeton POS"}}</p>
    <p>{{settings&&settings.shop?settings.shop.phone:"0506340523 / 0545254104"}}</p>
  </div>
</template>

<script>
import  { mapGetters } from 'vuex'
export default {
  data(){
    return {

    }
  },
   computed: {
    ...mapGetters({
      settings: "settings/SETTINGS",
    })
  },
}
</script>